import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "../../utlils/axios";
import { dispatch } from "../index"
import { handleSnackbar } from "../../utlils/snackbar";


interface LOVDropdownList {
    [key: string]: string | number | null;
}

interface DashboardLOVDropdownList {
    [key: string]: string;
}

interface varianceFieldValueState {
    [key: string]: string;
}

interface upsetFieldValueState {
    [key: string]: string
}

interface ModelDropdownList {
    [key: string]: string;
}

interface TrendLOVDropdownList {
    [key: string]: string | null
}

interface CostTrendLOVDropdownList {
    [key: string]: string | null
}

type dashboardSystemDate = string

type trendLOVDatatype = TrendLOVDropdownList[]

type costTrendLOVDatatype = CostTrendLOVDropdownList[]

type dashboardSingleLOVData = string

interface dashboardFieldLabelList {
    trendLOVField1: string,
    trendLOVField2: string,
    kpiStaticField1: string,
    kpiStaticField2: string,
    percentageMeterField1: string,
    percentageMeterField2: string,
    percentageMeterField3: string,
    percentageMeterField4: string,
    percentageMeterField5: string,
    percentageMeterField6: string,
    percentageMeterField7: string,
    percentageMeterField8: string,
    percentageMeterVarianceField1: string,
    percentageMeterVarianceField2: string,
    percentageMeterVarianceField3: string,
    percentageMeterVarianceField4: string,
    percentageMeterVarianceField5: string,
    percentageMeterVarianceField6: string,
    percentageMeterVarianceField7: string,
    percentageMeterVarianceField8: string,
    pouField1Value: string,
    pouField2Value: string,
    pouField3Value: string,
    pouField4Value: string,
    pouField5Value: string,
    pouField6Value: string,
    pouField7Value: string,
    pouField8Value: string,
    pouField1Comments: string,
    pouField2Comments: string,
    pouField3Comments: string,
    pouField4Comments: string,
    pouField5Comments: string,
    pouField6Comments: string,
    pouField7Comments: string,
    pouField8Comments: string,
    costField1: string,
    costField2: string,
    costField3: string,
    costField4: string,
    costField5: string,
    costField6: string,
    costField7: string,
    kpiLOVField1: string,
    kpiLOVField2: string,
    kpiLOVField3: string,
    kpiLOVField4: string
    kpiLOVField5: string
    kpiLOVField6: string
    kpiLOVField7: string
    kpiLOVField8: string,
    costFieldTrend1: string,
    costFieldTrend1Label: string,
    costField1Label: string,
    costField2Label: string,
    costField3Label: string,
    costField4Label: string,
    costField5Label: string
    costField6Label: string
    costField7Label: string
}


interface StateValues {
    LOVDropdownList: LOVDropdownList;
    ModelList: ModelDropdownList[];
    dashboardSystemDate: dashboardSystemDate;
    dashboardFieldLabelList: dashboardFieldLabelList;
    dashboardFieldValueList: dashboardFieldLabelList;
    dashboardSingleLOVValue: dashboardSingleLOVData;
    trendLOVData: trendLOVDatatype;
    costTrendData: costTrendLOVDatatype;
    varianceDropdownList: DashboardLOVDropdownList[];
    upsetDropdownList: DashboardLOVDropdownList[];
    varianceFieldValues: varianceFieldValueState;
    upsetFieldValue: upsetFieldValueState;
    recommendationDetails: [];
}

const initialState: StateValues = {
    upsetFieldValue: {},
    LOVDropdownList: {},
    recommendationDetails: [],
    varianceFieldValues: {},
    varianceDropdownList: [],
    upsetDropdownList: [],
    ModelList: [],
    trendLOVData: [],
    costTrendData: [],
    dashboardSystemDate: "",
    dashboardSingleLOVValue: "",
    dashboardFieldLabelList: {
        trendLOVField1: "",
        trendLOVField2: "",
        kpiStaticField1: "",
        kpiStaticField2: "",
        percentageMeterField1: "",
        percentageMeterField2: "",
        percentageMeterField3: "",
        percentageMeterField4: "",
        percentageMeterField5: "",
        percentageMeterField6: "",
        percentageMeterField7: "",
        percentageMeterField8: "",
        pouField1Value: "",
        pouField2Value: "",
        pouField3Value: "",
        pouField4Value: "",
        pouField5Value: "",
        pouField6Value: "",
        pouField7Value: "",
        pouField8Value: "",
        pouField1Comments: "",
        pouField2Comments: "",
        pouField3Comments: "",
        pouField4Comments: "",
        pouField5Comments: "",
        pouField6Comments: "",
        pouField7Comments: "",
        pouField8Comments: "",
        costField1: "",
        costField2: "",
        costField3: "",
        costField4: "",
        costField5: "",
        costField6: "",
        costField7: "",
        kpiLOVField1: "",
        kpiLOVField2: "",
        kpiLOVField3: "",
        kpiLOVField4: "",
        kpiLOVField5: "",
        kpiLOVField6: "",
        kpiLOVField7: "",
        kpiLOVField8: "",
        costFieldTrend1: "",
        costFieldTrend1Label: "",
        percentageMeterVarianceField1: "",
        percentageMeterVarianceField2: "",
        percentageMeterVarianceField3: "",
        percentageMeterVarianceField4: "",
        percentageMeterVarianceField5: "",
        percentageMeterVarianceField6: "",
        percentageMeterVarianceField7: "",
        percentageMeterVarianceField8: "",
        costField1Label: "",
        costField2Label: "",
        costField3Label: "",
        costField4Label: "",
        costField5Label: "",
        costField6Label: "",
        costField7Label: ""
    },
    dashboardFieldValueList: {
        trendLOVField1: "",
        trendLOVField2: "",
        kpiStaticField1: "",
        kpiStaticField2: "",
        percentageMeterField1: "",
        percentageMeterField2: "",
        percentageMeterField3: "",
        percentageMeterField4: "",
        percentageMeterField5: "",
        percentageMeterField6: "",
        percentageMeterField7: "",
        percentageMeterField8: "",
        pouField1Value: "",
        pouField2Value: "",
        pouField3Value: "",
        pouField4Value: "",
        pouField5Value: "",
        pouField6Value: "",
        pouField7Value: "",
        pouField8Value: "",
        pouField1Comments: "",
        pouField2Comments: "",
        pouField3Comments: "",
        pouField4Comments: "",
        pouField5Comments: "",
        pouField6Comments: "",
        pouField7Comments: "",
        pouField8Comments: "",
        costField1: "",
        costField2: "",
        costField3: "",
        costField4: "",
        costField5: "",
        costField6: "",
        costField7: "",
        kpiLOVField1: "",
        kpiLOVField2: "",
        kpiLOVField3: "",
        kpiLOVField4: "",
        kpiLOVField5: "",
        kpiLOVField6: "",
        kpiLOVField7: "",
        kpiLOVField8: "",
        costFieldTrend1: "",
        costFieldTrend1Label: "",
        percentageMeterVarianceField1: "",
        percentageMeterVarianceField2: "",
        percentageMeterVarianceField3: "",
        percentageMeterVarianceField4: "",
        percentageMeterVarianceField5: "",
        percentageMeterVarianceField6: "",
        percentageMeterVarianceField7: "",
        percentageMeterVarianceField8: "",
        costField1Label: "",
        costField2Label: "",
        costField3Label: "",
        costField4Label: "",
        costField5Label: "",
        costField6Label: "",
        costField7Label: ""
    }
};

const dashboardSlice = createSlice({
    name: "dashboardSlice",
    initialState,
    reducers: {
        getLOVDropDown(state, action) {
            state.LOVDropdownList = action.payload
        },
        getModelDropdown(state, action) {
            state.ModelList = action.payload
        },
        getDashboardSystemDateValue(state, action) {
            state.dashboardSystemDate = action.payload
        },
        getDashboardFieldLabel(state, action) {
            state.dashboardFieldLabelList = action.payload
        },
        getDashboardFieldValue(state, action) {
            state.dashboardFieldValueList = action.payload
        },
        getDashboardSingleLOVFieldValue(state, action) {
            state.dashboardSingleLOVValue = action.payload
        },
        getDashboardtrendLOVFieldValue(state, action) {
            state.trendLOVData = action.payload
        },
        getDashboardCostTrendFieldValue(state, action) {
            state.costTrendData = action.payload
        },
        getVarianceDropdownListData(state, action) {
            state.varianceDropdownList = action.payload
        },
        getUpsetDropdownListData(state, action) {
            state.upsetDropdownList = action.payload
        },
        getVarianceFieldValuesData(state, action) {
            state.varianceFieldValues = action.payload
        },
        getUpsetFieldValueData(state, action) {
            state.upsetFieldValue = action.payload
        },
        getDashboardRecommendationDetailsDate(state, action) {
            state.recommendationDetails = action.payload
        }
    },
});

// Reducer
export default dashboardSlice.reducer;

// Get Variance LOV Data
export const getVarianceDropdownList = (modelCode
    : string) => {
    return async () => {
        const url = `/dashboard/field-list-variance/${modelCode}`
        try {
            const response = await axios.get(url)
            dispatch(dashboardSlice.actions.getVarianceDropdownListData(response.data))
        } catch (error) {
            dispatch(handleSnackbar(error));
        }
    }
}

export const getVarianceFieldValue = (modelCode: string, logDate: string, varianceCode: string) => {
    return async () => {
        const url = `/dashboard/variance-field-values/${modelCode}/${logDate}/${varianceCode}`
        try {
            const response = await axios.get(url)
            dispatch(dashboardSlice.actions.getVarianceFieldValuesData(response.data))
            return response
        } catch (error) {
            dispatch(handleSnackbar(error))
        }
    }
}

// Get Upset LOV Data
export const getUpsetDropdownList = (modelCode
    : string) => {
    return async () => {
        const url = `/dashboard/field-list-upset/${modelCode}`
        try {
            const response = await axios.get(url)
            dispatch(dashboardSlice.actions.getUpsetDropdownListData(response.data))
        } catch (error) {
            dispatch(handleSnackbar(error));
        }
    }
}

// Get Trend LOV Graph Data 
export const getDashboardtrendLOVFieldValueData = (field1Code
    : string, field2Code: string, logDate: string, modelCode: string) => {
    return async () => {
        const url = `/dashboard/field-value/last-30-days/${logDate}/${modelCode}?field1Code=${field1Code}&field2Code=${field2Code}`
        try {
            const response = await axios.get(url)
            dispatch(dashboardSlice.actions.getDashboardtrendLOVFieldValue(response.data))
        } catch (error) {
            dispatch(handleSnackbar(error));
        }
    }
}

// Get Cost Trend  Graph Data 
export const getDashboardCostTrendFieldValueData = (field1Code
    : string, field2Code: string, logDate: string, modelCode: string) => {
    return async () => {
        const url = `/dashboard/field-value/last-90-days/${logDate}/${modelCode}?field1Code=${field1Code}&field2Code=${field2Code}`
        try {
            const response = await axios.get(url)
            dispatch(dashboardSlice.actions.getDashboardCostTrendFieldValue(response.data))
        } catch (error) {
            dispatch(handleSnackbar(error));
        }
    }
}

//Get Single LOV Dashboard Value 
export const getDashboardSingleLOVFieldValueList = (modelCode: string, fieldCode: string, logDate: string, componentCode: string) => {
    return async () => {
        const url = `/dashboard/field-value/${modelCode}/${fieldCode}/${componentCode}/${logDate}`
        try {
            const response = await axios.get(url)
            dispatch(dashboardSlice.actions.getDashboardSingleLOVFieldValue(response.data))
            return response
        } catch (error) {
            dispatch(handleSnackbar(error));
        }
    }
}


//Get Dashboard Value List
export const getDashboardFieldValueList = (modelCode: string, logDate: string, kpiLOVField1: string, kpiLOVField2: string, kpiLOVField3: string, kpiLOVField4: string, kpiLOVField5: string, kpiLOVField6: string, kpiLOVField7: string, kpiLOVField8: string, varianceLOVField1: string, varianceLOVField2: string, varianceLOVField3: string, varianceLOVField4: string, varianceLOVField5: string, varianceLOVField6: string, varianceLOVField7: string, varianceLOVField8: string, pouLOVField1: string, pouLOVField2: string, pouLOVField3: string, pouLOVField4: string, pouLOVField5: string, pouLOVField6: string, pouLOVField7: string, pouLOVField8: string) => {
    return async () => {
        const url = `/dashboard/values/${modelCode}/${logDate}?kpiLOVField1=${kpiLOVField1}&kpiLOVField2=${kpiLOVField2}&kpiLOVField3=${kpiLOVField3}&kpiLOVField4=${kpiLOVField4}&kpiLOVField5=${kpiLOVField5}&kpiLOVField6=${kpiLOVField6}&kpiLOVField7=${kpiLOVField7}&kpiLOVField8=${kpiLOVField8}&varianceLOVField1=${varianceLOVField1}&varianceLOVField2=${varianceLOVField2}&varianceLOVField3=${varianceLOVField3}&varianceLOVField4=${varianceLOVField4}&varianceLOVField5=${varianceLOVField5}&varianceLOVField6=${varianceLOVField6}&varianceLOVField7=${varianceLOVField7}&varianceLOVField8=${varianceLOVField8}&pouLOVField1=${pouLOVField1}&pouLOVField2=${pouLOVField2}&pouLOVField3=${pouLOVField3}&pouLOVField4=${pouLOVField4}&pouLOVField5=${pouLOVField5}&pouLOVField6=${pouLOVField6}&pouLOVField7=${pouLOVField7}&pouLOVField8=${pouLOVField8}`
        try {
            const response = await axios.get(url)
            dispatch(dashboardSlice.actions.getDashboardFieldValue(response.data))
            return response
        } catch (error) {
            dispatch(handleSnackbar(error));
        }
    }
}

// Get Dashboard Label Value 
export const getDashboardFieldLabelList = (modelCode: string) => {
    return async () => {
        const url = `/dashboard/model-field-labels/${modelCode}`
        try {
            const response = await axios.get(url)
            dispatch(dashboardSlice.actions.getDashboardFieldLabel(response.data))
            return response
        } catch (error) {
            dispatch(handleSnackbar(error));
        }
    }
}


// GET Dashboard System Date 
export const getDashboardSystemDate = (modelCode: string) => {
    return async () => {
        const url = `/dashboard/default-dashboard-date/${modelCode}`
        try {
            const response = await axios.get(url)
            dispatch(dashboardSlice.actions.getDashboardSystemDateValue(response.data))
            return response
        }
        catch (error) {
            dispatch(handleSnackbar(error));
        }
    }
}

// GET Model List
export const getModelList = () => {
    return async () => {
        const url = "dashboard/model-list"
        try {
            const response = await axios.get(url);
            dispatch(dashboardSlice.actions.getModelDropdown(response.data))
        } catch (error) {
            dispatch(handleSnackbar(error));
        }
    }
}

// Get LOV DropDown List
export const getLOVDropDownList = (modelCode: string) => {
    return async () => {
        const url = `/dashboard/numeric-field-list/${modelCode}`;
        try {
            const response = await axios.get(url);
            dispatch(dashboardSlice.actions.getLOVDropDown(response.data));
        } catch (error) {
            dispatch(handleSnackbar(error));
        }
    }
};

// GET UPSET Field Values
export const getUpsetFieldValue = (modelCode: string, fieldCode: string, logDate: string) => {
    return async () => {
        const url = `/dashboard/field-value-upset/${modelCode}/${fieldCode}/${logDate}`;
        try {
            const response = await axios.get(url);
            dispatch(dashboardSlice.actions.getUpsetFieldValueData(response.data))
            return response
        } catch (error) {
            dispatch(handleSnackbar(error));
        }
    }
}

// Get Recommendation Details Data
export const getDashboardRecommendationDetails = (logDate: string, modelCode
    : string) => {
    return async () => {
        const url = `/dashboard/recommendation-list/${logDate}/${modelCode}`
        try {
            const response = await axios.get(url)
            dispatch(dashboardSlice.actions.getDashboardRecommendationDetailsDate(response.data))
        } catch (error) {
            dispatch(handleSnackbar(error));
        }
    }
}